import api from "./";

export const obterIndexadores = async (obj) => {
    try {
        const { data } = await api.post("/custos/obterIndexadores", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

const objetoDeFuncoes = {
    obterIndexadores,
};

export default objetoDeFuncoes;
